// Short markdown note shown above a client's setup snippet when the MCP server uses OAuth.
// These generators produce plain markdown (not React), so the copy is inlined in English to
// match the rest of the hard-coded instruction text in this folder.
const OAUTH_NOTE = `> ℹ️ **This server uses OAuth.** No API key is needed. The first time you connect, your client opens a browser window so you can sign in and authorize access.

`;

export default OAUTH_NOTE;
